/**
 * permessi.js — chi puo' fare cosa, nel frontend, in un posto solo.
 *
 * Il server e' la protezione (ogni rotta controlla il ruolo); qui si
 * allinea cio' che si mostra, perche' un collegamento che porta a un 403
 * insegna a diffidare dei collegamenti. La regola e' la stessa di
 * puoVedereDettaglio nel backend: un permesso ha UN nome e UN posto, e
 * le schermate lo importano. Non si riscrive `['admin', 'segreteria']`
 * dentro un componente: il 19 settembre 2026 `puoOrganizzare` e' stato
 * dichiarato dentro un componente e usato in un altro, e l'agenda e'
 * andata giu' in render per tre giorni senza che la build dicesse
 * niente.
 */

/* Le schermate del front-desk: cassa, anagrafiche di fatturazione,
   tessera sanitaria, magazzino, orari e stanze. Il backend le riserva ad
   admin e segreteria. Le rotte di App.js e i collegamenti che ci portano
   leggono QUESTO elenco. */
export const FRONT_DESK = ['admin', 'segreteria'];

/** Orari delle agende e stanze: le rotte /orari e /stanze. */
export const puoOrganizzare = (ruolo) => FRONT_DESK.includes(ruolo);
